import { z } from "zod";
import configJson from "./order-price-filter.json";

const configSchema = z.object({
  enabled: z.boolean(),
  errors: z.object({ invalid: z.string(), forbidden: z.string(), disabled: z.string() }),
});
const CONFIG = configSchema.parse(configJson);

export const ORDER_PRICE_FILTER_ENABLED = CONFIG.enabled;
export const ORDER_PRICE_FILTER_ERRORS = CONFIG.errors;
